import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InViewportModule } from 'ng-in-viewport';

import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { FocusOnLoadModule } from '../shared/focus-on-load/focus-on-load.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { SharePointSiteComponent } from './sharepoint-site/sharepoint-site.component';
import { SharePointComponent } from './sharepoint.component';

@NgModule({
    imports: [
        CommonModule,
        FocusOnLoadModule,
        IconFontModule,
        InstrumentationModule,
        InViewportModule,
        SharedComponentsModule
    ],
    declarations: [
        SharePointSiteComponent,
        SharePointComponent
    ],
    exports: [
        SharePointComponent
    ]
})
export class SharePointModule {
}
